import { Button } from '@Calix-Commerce/design-system/components';
import { DownloadDiv } from 'pages/Order/styledComponents.js';

const DownloadButton = ({ data, onClick, label }) => (
  <DownloadDiv>
    <Button colorVariant={'secondary'} onClick={() => onClick(data)}>
      {label}
    </Button>
  </DownloadDiv>
);

export { DownloadButton };
